const saveToStorage = (key, value) => {
  localStorage.setItem(key, value?.toString());
};

const getFromStorage = (key) => localStorage.getItem(key)?.toString();

export { saveToStorage, getFromStorage };
